// extracted by mini-css-extract-plugin
export default {"container":"lesson-overview-page_container__f2RP2","row":"lesson-overview-page_row__A1RmM","title":"lesson-overview-page_title__fhHX3"};